import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base.service';

interface APIParams {
  onet_code: string;
}

@Injectable({
  providedIn: 'root'
})
export class CareerGoalService extends BaseApiService {
  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/navigate-api' : environment.navigateApiUrl;
    super(http, apiBaseUrl);
  }

  setCareerGoalApi(data: APIParams): Observable<any> {
    return this.post<any>('user-careers', {
      onet_code: data.onet_code,
      type: 'career_goal',
    });
  }

  unsetCareerGoalApi(): Observable<any> {
    return this.post<any>('user-careers', {
      unset: true
    });
  }
}
